import YFooterPhone from './index.vue';
export default YFooterPhone